import React, { useState } from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import useJumpBackAndResetDeposit from '../../../../../../../hooks/useJumpBackAndResetDeposit';
import type { PaySystemDetails } from '../../../../../../../types/Cashier';
import { composeFeeMessage } from '../../../../../../../utils/fee';
import Prompt from '../../../../../../Prompt/Prompt';
import type { Props } from '../DepositFeePrompts';

import {
  TXTWCL_Continue_anyway,
  TXTWCL_Deposit_another_way,
  TXTWCL_Just_so_you_know
} from './FeePromptDefault.messages.json';

const FeePromptDefault: React.FC<Omit<Props, 'onClose'>> = ({ onConfirm }) => {
  const [feeAcknowledged, setFeeAcknowledged] = useState(false);
  const {
    data: { paySystems, paySystemDetails, bonusReadySystems },
    values
  } = useWizardContext();
  const jumpBackAndResetDeposit = useJumpBackAndResetDeposit();

  const {
    deposit: { bonusCode = '' }
  } = values;
  const {
    type,
    paysysFee: paySystemFee,
    rates: { curr: balanceCurrency }
  }: PaySystemDetails = paySystemDetails;

  const getAlertMessage = () => {
    const message = composeFeeMessage(
      type,
      paySystemFee,
      balanceCurrency,
      paySystems,
      bonusCode,
      bonusReadySystems
    );

    return message.map((item, index) => (
      <div key={index}>
        <div>{item}</div>
        {index < message.length - 1 && <br />}
      </div>
    ));
  };

  const onConfirmHandler = () => {
    setFeeAcknowledged(true);
    onConfirm();
  };

  if (feeAcknowledged) {
    return null;
  }

  return (
    <Prompt
      title={{ translation: TXTWCL_Just_so_you_know }}
      primaryButton={{
        translation: TXTWCL_Continue_anyway
      }}
      onPrimaryButtonClick={onConfirmHandler}
      onSecondaryButtonClick={() => jumpBackAndResetDeposit('#deposit.deposit-method')}
      secondaryButton={{ translation: TXTWCL_Deposit_another_way }}
      noCloseButton
      variant="info"
      alert={getAlertMessage()}
    />
  );
};

export default FeePromptDefault;
